import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography } from '@mui/material';
import { auth, db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const AddBook = () => {
  const navigate = useNavigate();
  const [bookData, setBookData] = useState({
    title: '',
    authors: '',
    publisher: '',
    thumbnail: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userId = auth.currentUser?.uid;
      if (!userId) {
        alert('로그인이 필요합니다.');
        return;
      }

      await addDoc(collection(db, 'books'), {
        ...bookData,
        uid: userId,
        createdAt: serverTimestamp()
      });

      alert('책이 성공적으로 등록되었습니다!');
      navigate('/');
    } catch (error) {
      console.error('책 등록 오류:', error);
      alert('책 등록에 실패했습니다.');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>새 책 추가</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="책 제목"
          value={bookData.title}
          onChange={(e) => setBookData({ ...bookData, title: e.target.value })}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="저자"
          value={bookData.authors}
          onChange={(e) => setBookData({ ...bookData, authors: e.target.value })}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="출판사"
          value={bookData.publisher}
          onChange={(e) => setBookData({ ...bookData, publisher: e.target.value })}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="표지 이미지 URL"
          value={bookData.thumbnail}
          onChange={(e) => setBookData({ ...bookData, thumbnail: e.target.value })}
          margin="normal"
        />
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" fullWidth>
            책 등록하기
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddBook; 